module.exports = __webpack_public_path__ + "static/media/PM75.b04e4a93.JPG";